/** @format */
import { css } from 'styled-components';

import {
    largeDesktop,
    largeTablet,
    smallTablet,
} from '@toucan/client/global/application';

export const styles = css`
    padding: var(--layout-spacing-96) 0;
    overflow: hidden;

    .featured-articles-block__container {
        display: grid;
        grid-template-areas:
            'title see-all'
            'carousel carousel'
            'navigation navigation';
        grid-template-columns: 1fr auto;
        row-gap: var(--layout-spacing-32);
        align-items: end;
    }

    .featured-articles-block__title {
        grid-area: title;
        margin: 0;
        letter-spacing: var(--typography-letter-spacing-tight);
        font-size: var(--typography-font-size-7xl);
    }

    .featured-articles-block__see-all {
        grid-area: see-all;
        align-self: center;
    }

    .featured-articles-block__carousel {
        grid-area: carousel;
        display: flex;
        list-style: none;
        margin: 0;
        padding: 0;
        touch-action: none;
        cursor: grab;

        * {
            user-select: none;
        }

        img {
            pointer-events: none;
        }
    }

    .featured-articles-block__navigation {
        grid-area: navigation;
        display: flex;
        gap: var(--layout-spacing-16);
    }

    ${largeDesktop(css`
        .featured-articles-block__container {
            row-gap: var(--layout-spacing-40);
        }
    `)}

    ${largeTablet(css`
        padding: var(--layout-spacing-64) 0;
    `)}

    ${smallTablet(css`
        padding: var(--layout-spacing-48) 0;

        .featured-articles-block__container {
            grid-template-areas:
                'title title'
                'carousel carousel'
                'see-all navigation';
            row-gap: var(--layout-spacing-32);
            align-items: center;
        }

        .featured-articles-block__see-all {
            width: max-content;
        }

        .featured-articles-block__carousel {
            margin-bottom: var(--layout-spacing-32);
        }

        .featured-articles-block__navigation {
            justify-self: end;
        }
    `)}
`;
